export default {
    name: 'facteurs-ponderations',
    components: {},
    props: ["consultation", "is_printable"],
    data() {
        return {
            fields: ['designation', { key: 'oui', label: '' }, ],
            facteurs: [{
                designation: 'FACTEUR DE PONDERATION',
                oui: '',
                ponderation: 2,
                conferer: 'Ordino. 5'
            }],
            perPage: 10,
            currentPage: 1,
            state: null,
            loading: false,

            point: 0,
            conclusion: '',
        }
    },
    computed: {
        facteursPonderations() {
            return this.$store.getters["facteursPonderations"];
        },

    },
    mounted() {
        this.$store.dispatch('getFacteursPonderations', { id: this.consultation.id, enCours: true }).then((response) => {
            console.log('FP: ', response)
            this.point = 0;
            for (var i = 0; i < response.length; i++) {
                if (parseInt(response[i].selected) === 1) {
                    this.point += parseInt(response[i].facteur_ponderation)
                }
            }
            if (this.point === 0) {
                this.conclusion = " CPN à suivre"
            } else if (this.point === 1) {
                this.conclusion = "Surveiller"
            } else if (this.point === 2) {
                this.conclusion = "Conseiller ou surveiller ou traiter ou référer si nécessaire "
            } else {
                this.conclusion = "Réferer"
            }
        });
    },
    methods: {
        /**
         * Dis si la sage femme peut voir le score issu des facteurs de ponderation
         * @returns 
         */
        canSeeScore() {
            let err =  false
            for (let i = 0; i < this.facteursPonderations.length; i++) {
                if (this.facteursPonderations[i].selected != null) {
                    err = true
                }
            }

            console.log("ERR: ",err)

            return err
        },
    }
}